import React from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce'
import {Input} from 'antd'

class SearchField extends React.Component {
  state = {
    query: this.props.query,
  }

  executeSearch = () => {
    this.props.onSearch(this.state.query)
  }

  debouncedSearch = debounce(this.executeSearch, 200)

  updateQuery = (query) => {
    this.setState({query}, () => this.debouncedSearch(query))
  }

  onChange = (event) => {
    this.updateQuery(event.target.value)
  }

  render() {
    return (
      <Input.Search
        size="large"
        className={this.props.className}
        placeholder={this.props.placeholder}
        value={this.state.query}
        onChange={this.onChange}
        onSearch={this.updateQuery}
      />
    )
  }
}

SearchField.propTypes = {
  query: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
}

export default SearchField
